<template>
  <v-dialog lazy v-model="opened" max-width="256px" class="client-avatar-upload">
    <v-avatar
      slot="activator"
      :size="72"
      style="overflow: hidden;"
      :class="{ 'float-left': floatLeft }"
    >
      <img :src="src" />
      <div v-if="overlay" class="upload-overlay" :class="{ 'on-hover': hoverOverlay }">
        <div class="white--text text-xs-center pt-3">
          <v-icon small color="white">mdi-camera</v-icon><br />
          <span class="font-weight-bold">Update</span>
        </div>
      </div>
    </v-avatar>

    <!-- Avatar Upload Dialog -->
    <v-card>
      <v-card-title class="headline">Upload Avatar</v-card-title>
      <v-img height="256px" :src="image && preview ? preview : src">
        <v-container fill-height>
          <v-layout column align-center justify-top>
            <v-btn
              :color="themes.client.light.primaryActionButton"
              @click.native="$refs.file.click()"
            >
              Click to Upload
            </v-btn>
          </v-layout>
        </v-container>
        <input type="file" name="file" ref="file" @change="setFile" style="display: none;" />
      </v-img>
      <v-card-actions>
        <v-btn block :color="themes.client.light.cancel" flat @click="opened = false">cancel</v-btn>
        <v-btn block :color="themes.client.light.secondaryActionButton" @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Vue Component
export default {
  props: {
    floatLeft: { type: Boolean, default: () => false },
    hoverOverlay: { type: Boolean, default: () => false },
    overlay: { type: Boolean, default: () => false },
    path: String,
    src: String,
  },
  data() {
    return {
      opened: false,
      image: null,
      preview: null,
    }
  },
  methods: {
    setFile() {
      this.image = this.$refs.file.files[0]
      const reader = new FileReader()
      reader.addEventListener('load', () => (this.preview = reader.result), false)
      if (this.image) reader.readAsDataURL(this.image)
    },
    submit() {
      if (this.image) {
        let formData = new FormData()
        formData.append('avatar', this.image)
        this.$http
          .post(this.path, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(() => this.$emit('success'))
          .then(() => (this.opened = false))
      }
    },
  },
}
</script>

<style lang="scss">
.client-avatar-upload {
  .float-left {
    left: -36px;
    position: absolute;
    top: 0;
  }

  .upload-overlay {
    background-color: rgba(0, 0, 0, 0.2);
    bottom: 0px;
    height: 100%;
    position: absolute;
    transition: opacity 0.5s ease;
    width: 100%;

    &.on-hover {
      opacity: 0;
    }
    &.on-hover:hover {
      opacity: 1;
    }
  }
}
</style>
